// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"Options_optionsWrapper__+FXGX","option":"Options_option__MU1R1"};